import api from 'config/Api/Api';

const baseEndpoint = 'v1/direct-dial';

export default {
  getDdis( params ) {
    return api.get( baseEndpoint, params );
  },
};
